import React from "react";

export type THourglassAnimateIconProps = React.SVGAttributes<SVGElement>;

export function HourglassAnimateIcon({ ...rest }: THourglassAnimateIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none" {...rest}>
      <style>
        {`@keyframes a0_t { 
          0% { transform: translate(13px,13px) rotate(0deg) translate(-13px,-13px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 
          10% { transform: translate(13px,13px) rotate(180deg) translate(-13px,-13px); } 
          50% { transform: translate(13px,13px) rotate(180deg) translate(-13px,-13px); animation-timing-function: cubic-bezier(0,0,0.58,1); } 
          60% { transform: translate(13px,13px) rotate(360deg) translate(-13px,-13px); } 
          100% { transform: translate(13px,13px) rotate(360deg) translate(-13px,-13px); } }`}
      </style>
      <g transform="translate(13,13) translate(-13,-13)">
        <path d="M9,21L17,21L17,18C17,16.9,16.6083,15.9583,15.825,15.175C15.0417,14.3917,14.1,14,13,14C11.9,14,10.9583,14.3917,10.175,15.175C9.39167,
        15.9583,9,16.9,9,18L9,21ZM13,12C14.1,12,15.0417,11.6083,15.825,10.825C16.6083,10.0417,17,9.1,17,8L17,5L9,5L9,8C9,9.1,9.39167,10.0417,10.175,
        10.825C10.9583,11.6083,11.9,12,13,12ZM5,23L5,21L7,21L7,18C7,16.9833,7.2375,16.0292,7.7125,15.1375C8.1875,14.2458,8.85,13.5333,9.7,13C8.85,
        12.4667,8.1875,11.7542,7.7125,10.8625C7.2375,9.97083,7,9.01667,7,8L7,5L5,5L5,3L21,3L21,5L19,5L19,8C19,9.01667,18.7625,9.97083,18.2875,
        10.8625C17.8125,11.7542,17.15,12.4667,16.3,13C17.15,13.5333,17.8125,14.2458,18.2875,15.1375C18.7625,16.0292,19,16.9833,19,18L19,21L21,
        21L21,23L5,23Z" fill="#7F94A1" transform="translate(13,13) translate(-13,-13)" style={{ animation: "5s linear infinite both a0_t" }} />
      </g>
    </svg>

  );
}
